(function (global) {
  const config = document.getElementById('bodycare-chat-config');
  const placeholder = document.querySelector('[data-bodycare-chat-placeholder]');
  if (!config || !placeholder) return;

  let loadPromise;
  const token = config.dataset.embedToken;

  function load() {
    if (loadPromise) return loadPromise;
    placeholder.setAttribute('aria-busy', 'true');
    loadPromise = global.BodycareAssets.loadScript('https://r2.spurnow.com/lc-widget/embed.js', {
      'data-embed-token': token
    }).then(() => placeholder.remove()).catch((error) => {
      loadPromise = null;
      placeholder.removeAttribute('aria-busy');
      console.warn('Unable to initialize chat.', error);
    });
    return loadPromise;
  }

  placeholder.addEventListener('pointerover', load, { once: true });
  placeholder.addEventListener('focus', load, { once: true });
  placeholder.addEventListener('click', load, { once: true });

  if ('requestIdleCallback' in global) global.requestIdleCallback(load, { timeout: 5000 });
  else global.setTimeout(load, 4000);
})(window);
